var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.data,"hideDefaultFooter":""},scopedSlots:_vm._u([{key:"item.status",fn:function(ref){
var item = ref.item;
return [_c('v-chip',{attrs:{"color":_vm.getColor(item.status),"dark":""}},[_c('span',[_vm._v(_vm._s(_vm.convertMinutes(item.minutes)))])])]}},{key:"item.listOffline",fn:function(ref){
var item = ref.item;
return [(item.listOffline)?_c('history-offline',{attrs:{"playerID":item.id,"playerName":item.name}}):_vm._e()]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }